export default Object.freeze({
  dsn: process.env.REACT_APP_SENTRY_DSN,
});
